<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title">
      @if (!description) {
        {{ 'setting-edit-title-modal' | translate }} {{ parameter }}
      } @else {
        {{ 'setting-edit-title-modal-description' | translate }} {{ parameter }}
      }
    </h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center" id="inputs">
      @if (!dico) {
        <input class="form-control" [formControl]="formEdit">
      } @else {
        <div class="d-flex flex-row align-items-center">
          <input class="form-control keyF" [(ngModel)]="key" readonly>
          <h3> : </h3>
          <input class="form-control valueF" [formControl]="formEdit">
        </div>
      }
      @if (formEdit.invalid && formEdit.dirty) {
        <div class="alert alert-danger">
          @if (formEdit.errors?.['required']) {
            <div>{{ 'setting-form-error-required' | translate }}</div>
          }
          @if (ltocompare && formEdit.errors?.['exist']) {
            <div>{{ 'setting-form-error-already-exist' | translate }}</div>
          }
          @if (formEdit.errors?.['whitespace']) {
            <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
          }
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" [disabled]="formEdit.invalid"
      (click)="sendValue();c('Save click');">{{ 'confirm' | translate }}</button>
  </div>
</ng-template>

@if (!description) {
  <img type="button" (click)="open({ content: content })" class="edit" src="assets/icons/Settings/edit.svg">
}
@if (description) {
  <img type="button" (click)="open({ content: content })" class="descriptionE" src="assets/icons/Settings/edit.svg">
}